import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CmsHttpClient } from '@cms_root/app/api-clients/cms/cms-http-client.service';
import { environment } from '@cms_root/environments/environment';
import { User, RoleAssignment } from '../models/user.model';
import { map } from 'rxjs/operators';
import { Role } from '@cms_root/app/roles/models/role';

@Injectable({
  providedIn: 'root'
})
export class UserApiService {
  private readonly apiUsersUrl = `${environment.cmsApi}api/users`;

  constructor(private readonly cmsHttpClient: CmsHttpClient) {}

  public getCurrentUser(): Observable<User> {
    return this.getUser(0);
  }

  public getUser(id: number): Observable<User> {
    const headers = new HttpHeaders({ 'Cache-Control': ['no-cache', 'private'] });

    return this.cmsHttpClient.get<User>(`${this.apiUsersUrl}/${id}`, { headers });
  }

  public getUserRoles(userId: number): Observable<Role[]> {
    const headers = new HttpHeaders({ 'Cache-Control': ['no-cache', 'private'] });
    return this.cmsHttpClient
      .get<RoleAssignment[]>(`${this.apiUsersUrl}/${userId}/role_assignments`, { headers })
      .pipe(map((permissions) => permissions.map((userPermission) => userPermission.role.name as Role)));
  }
}
